import type { AccountSettings } from '../../lib/postTypes'

/** 各セクション共通の props（保存前の編集は draft に持つ） */
export interface SectionProps {
  draft: AccountSettings
  setDraft: (s: AccountSettings) => void
}

/** 選択式ボタン（トグル）の共通クラス */
export const choiceCls = (active: boolean) =>
  `rounded-ctl border px-3 py-1.5 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${
    active ? 'border-primary bg-primary-subtle font-bold text-primary' : 'border-line-strong bg-surface hover:bg-surface-2'
  }`
